<template>
	<div>
		<div class="header-item">
				<h1>Pages <router-link class="btn-edit" :to="`/pages/edit/22`"><i class="fa fa-pen"></i></router-link></h1>
		</div>

		<router-view :content="content"></router-view>
	</div>
</template>

<script>

import xhrModule from '../modules/xhrModule.js'

export default {
	name: 'pages',

	data () {
		return {
			content: null
		}
	},

	created () {
		this.fetchData()
	},

	methods: {
		fetchData () {
			var url = '/cms/api/entities'
			xhrModule.get(url, this.getContentCompleteHandler.bind(this))
		},

		getContentCompleteHandler (data) {
			this.content = Object.values(data.data)
		}
	}
}
</script>
